export const THEME_STORAGE_KEY = 'mmjadmin.theme';
export const LANG_STORAGE_KEY = 'mmjadmin.lang';

export function readStored(key, fallback) {
  try {
    return window.localStorage.getItem(key) || fallback;
  } catch {
    return fallback;
  }
}

export function writeStored(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* noop */
  }
}

export function resolveTheme(theme) {
  if (theme === 'system') {
    if (typeof window !== 'undefined' && window.matchMedia) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
  }
  return theme === 'dark' ? 'dark' : 'light';
}

export function applyTheme(theme) {
  if (typeof document === 'undefined') return;
  const resolved = resolveTheme(theme);
  document.documentElement.setAttribute('data-theme', resolved);
  const onAdmin = typeof window !== 'undefined' && (
    window.location.pathname.startsWith('/dashboard')
    || window.location.pathname.startsWith('/ekip')
  );
  document.body.classList.toggle('admin-dark-mode', onAdmin && resolved === 'dark');
}

export function applyLanguage(lang) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lang === 'en' ? 'en' : 'tr';
}

export function initAdminAppearance() {
  const theme = readStored(THEME_STORAGE_KEY, 'light');
  applyTheme(theme);
  applyLanguage(readStored(LANG_STORAGE_KEY, 'tr'));

  if (typeof window === 'undefined' || !window.matchMedia) return;
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const onChange = () => {
    if (readStored(THEME_STORAGE_KEY, 'light') === 'system') applyTheme('system');
  };
  if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onChange);
  else if (typeof mq.addListener === 'function') mq.addListener(onChange);
}
